import { render, staticRenderFns } from "./DoctorsTable.vue?vue&type=template&id=24576a42&"
import script from "./DoctorsTable.vue?vue&type=script&lang=js&"
export * from "./DoctorsTable.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports